import type { KeyboardEvent, MouseEvent } from 'react'
import { Search } from 'lucide-react'
import { useCommandPalette } from '@/components/command/useCommandPalette'
import { useIsMobile } from '@/hooks/useMediaQuery'
import s from './HeaderSearch.module.css'

/** The header field, sidebar pills, and shortcuts all open the same dialog;
 *  `data-search-anchor` marks this field as the rect the panel expands from. */
export function HeaderSearch() {
  const { mode, open } = useCommandPalette()
  const mobile = useIsMobile()
  function launch(event: MouseEvent<HTMLButtonElement>) {
    open('search', { anchor: event.currentTarget })
  }
  function type(event: KeyboardEvent<HTMLButtonElement>) {
    if (event.nativeEvent.isComposing || event.metaKey || event.ctrlKey || event.altKey || event.key.length !== 1 || event.key === ' ') return
    event.preventDefault()
    open('search', { anchor: event.currentTarget, query: event.key })
  }
  return (
    <button type="button" className={mobile ? s.trigger : s.field} aria-label={mobile ? 'Open search' : 'Search records and pages'} aria-haspopup="dialog" aria-expanded={mode !== null} data-search-anchor="" onClick={launch} onKeyDown={type}>
      <Search size={mobile ? 22 : 17} aria-hidden="true" />
      {!mobile && <><span className={s.placeholder}>Search anything…</span><kbd className={s.key}>/</kbd></>}
    </button>
  )
}
